import { render, staticRenderFns } from "./uploadId.vue?vue&type=template&id=2371bf12"
import script from "./uploadId.vue?vue&type=script&lang=js"
export * from "./uploadId.vue?vue&type=script&lang=js"
import style0 from "./uploadId.vue?vue&type=style&index=0&id=2371bf12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports